module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-v4compatibility.woff2?7c428138d15b872f193c40828f6fa0d3";